/**
 * EliorGroup.Joyfood.B2B API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { B2BCalendarShopDto } from './calendarShopDto';


export interface B2BCalendarDayDto { 
    date?: string;
    isOpen?: boolean;
    orderCount?: number;
    shops?: Array<B2BCalendarShopDto> | null;
}

